import { useInterval } from './useInterval';

type Options = {
  runCallbackOnRestoredFocusAndDelayElapsed?: boolean;
};

const defaultOptions: Options = {
  runCallbackOnRestoredFocusAndDelayElapsed: true,
};

export const useIntervalWhenWindowIsFocused = (
  callback: () => void,
  delay?: number | null,
  options: Options = defaultOptions,
) => {
  useInterval(
    () => {
      callback();
    },
    delay, // use null to pause the interval
  );
};
